import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { IMAGE_API } from "./apiRoutes";

const mutateAddAnnualReportingImage = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${IMAGE_API}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const useAddAnnualReportingImageMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddAnnualReportingImage,
    ...queryParams,
  });

export default useAddAnnualReportingImageMutation;
